<!-- <div class="margin-top-lg">
	<mat-card-title>
		<div class="row">
			<div class="col-4"> Communication Events</div>
			<mat-icon *ngIf="isLoading">
				<mat-spinner *ngIf="isLoading" diameter="30"></mat-spinner>
			</mat-icon>

			<div class="col-8" *ngIf="editing">
				<button *ngIf="addAccess" mat-raised-button color="primary" class="button-add-row" (click)="addRow()">
					Add Communication Event
				</button>
			</div>
		</div>
	</mat-card-title>
	<div class="row" style="padding-top: 5px;">
		<div class="col">
			<mat-divider></mat-divider>
		</div>
	</div>
	{{ boolFoundCommunicationEvents ==false ? studentName + ' does not have any communication events.' : '' }}
	<div *ngFor="let item of lstRegionbySCE">
		<div style="padding-top: 10px"
			*ngIf="item.editableSCE[0].studentCommunicationEvent.REGION.ID == this.userRegion.ID">
			<app-communication-table (modificationEvent)="invokeApiGetStudentCommunicationEvents($event)"
				[studentCommunicationEvents]="item.editableSCE" [studentId]="studentId"
				[editing]="editing"></app-communication-table>

		</div>

	</div>
	<div *ngFor="let item of lstRegionbySCE">
		<div *ngIf="item.editableSCE[0].studentCommunicationEvent.REGION.ID != this.userRegion.ID">
			<app-communication-table (modificationEvent)="invokeApiGetStudentCommunicationEvents($event)"
				[studentCommunicationEvents]="item.editableSCE" [studentId]="studentId"
				[editing]="editing"></app-communication-table>
		</div>
	</div>

	 -->

<div class="margin-top-lg">
	<mat-card-title class="h5">
		Communication Events
		<mat-icon *ngIf="isLoading">
			<mat-spinner diameter="18"></mat-spinner>
		</mat-icon>
		<span class="align-btn" *ngIf="editing">
			<button *ngIf="addAccess" mat-raised-button color="primary" class="button-add-row" (click)="addRow()">
				Add Communication Event
			</button>
		</span>
	</mat-card-title>


	<mat-card-content class="margin-top-lg" *ngIf="!isLoading && boolFoundCommunicationEvents == false">
		<hr />
		<h3>{{studentName + ' does not have any communication events.'}}</h3>
	</mat-card-content>

	<div class="row margin-top-lg">
		<div *ngFor="let item of lstRegionbySCE">
			<div class="margin-top-lg"
				*ngIf="item.editableSCE[0].studentCommunicationEvent.REGION.ID == this.userRegion.ID">
				<app-communication-table (modificationEvent)="invokeApiGetStudentCommunicationEvents($event)"
					[studentCommunicationEvents]="item.editableSCE" [studentId]="studentId"
					[editing]="editing"></app-communication-table>

			</div>

		</div>
		<div *ngFor="let item of lstRegionbySCE">
			<div *ngIf="item.editableSCE[0].studentCommunicationEvent.REGION.ID != this.userRegion.ID">
				<app-communication-table (modificationEvent)="invokeApiGetStudentCommunicationEvents($event)"
					[studentCommunicationEvents]="item.editableSCE" [studentId]="studentId"
					[editing]="editing"></app-communication-table>
			</div>
		</div>
	</div>
</div>